import React, { useState } from "react";
import  DentistApproval from "../../../CentralHub/Admin/pages/DentistApproval";
import MillingHubApproval from "../../../CentralHub/Admin/pages/MillingHubApproval"; 

import "bootstrap/dist/css/bootstrap.min.css";

const Approvals: React.FC = () => {  
  const [activeTab, setActiveTab] = useState<"DentistApproval" | "MillingApproval">("DentistApproval");

  return (
    <div className="">
      {/* <h3 className="mb-4 orders-text"> Hub Approvals</h3> */}

      {/* Tabs */}
      <div className="d-flex justify-content-center mb-5 mt-4 gap-3">
          <button
            className={`tab-btn ${activeTab === "DentistApproval" ? "active" : ""}`}
            onClick={() => setActiveTab("DentistApproval")}
          >
            Dentist Approval
          </button>
          <button
            className={`tab-btn ${activeTab === "MillingApproval" ? "active" : ""}`}
            onClick={() => setActiveTab("MillingApproval")}
          >
            Milling Approval
          </button>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === "DentistApproval" && <DentistApproval />}
        {activeTab === "MillingApproval" && <MillingHubApproval />}
      </div>
    </div>
  );
};

export default Approvals;
